export function estRouteSupervision(hash: string): boolean {
  return hash === '#/supervision' || hash.startsWith('#/supervision?');
}
